import { render, staticRenderFns } from "./Validate.vue?vue&type=template&id=13f2edaa"
import script from "./Validate.vue?vue&type=script&lang=js"
export * from "./Validate.vue?vue&type=script&lang=js"
import style0 from "./Validate.vue?vue&type=style&index=0&id=13f2edaa&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13f2edaa')) {
      api.createRecord('13f2edaa', component.options)
    } else {
      api.reload('13f2edaa', component.options)
    }
    module.hot.accept("./Validate.vue?vue&type=template&id=13f2edaa", function () {
      api.rerender('13f2edaa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/components/formSetting/components/form-create-designer/src/components/Validate.vue"
export default component.exports